import React, { Component } from 'react';
import Alibar from '@alife/bc-alibar';
import ClassNames from "classnames";
import PropTypes from 'prop-types';

class AliBarComponents extends Component {

  render() {
    const { width } = this.props;
    const clswarp = ClassNames({
      "alibar-wrapper": true,
      "w_1190": width === 1190,
      "w_990": width === 990,
      "w_1390": width === 1390
    })


    return (
      <div className={clswarp}>
        <Alibar width="response" color={'white'} />
      </div>
    );
  }
}

AliBarComponents.propTypes = {
  width: PropTypes.string
};

export default AliBarComponents;

